import { RecentCallins } from "../RecentCallins";
import { DataSource, Layout, Switch } from "@mcleod/components";

export abstract class AutogenLayoutMovementCallins extends Layout {
    layoutRecentCallins: RecentCallins;
    sourceMapData: DataSource;
    sourceMovement: DataSource;
    switchSwitchPositions: Switch;
}
